import { type DateObject, type UserRequirement } from '@capsicum/common';
import { type FanTokenOfferingWithPartner } from '@capsicum/socios-core';

import { type FanTokenOfferingData, type OrderReviewAmounts, type OrderReviewData } from './fanTokenOfferingData';
import { type FanTokenOfferingsPage } from './fanTokenOfferingsPage';

export type FanTokenOfferingsSectionProps = {
	page: FanTokenOfferingsPage;
	partnerId?: string | undefined;
};

export type FanTokenOfferingsCardCarouselProps = {
	fanTokenOfferings?: Array<FanTokenOfferingWithPartner>;
	page: string;
	walletCurrencies?: {
		altCurrencyId: string;
		altCurrencyShortCode: string;
		defaultCurrencyId: string;
		defaultCurrencyShortCode: string;
	};
};

export type FanTokenOfferingCardProps = {
	fto: FanTokenOfferingWithPartner;
	ftoIndex: number;
	isFullWidthCard?: boolean;
	onElapsed: () => void;
	page: FanTokenOfferingsPage;
};

export type FTOTimerProps = {
	expirationDate: DateObject;
	onElapsed: () => void;
	testID: string;
};

export type FTOBuyButtonProps = {
	onBuyClick: () => void;
	partnerId: string;
	quantityAvailable: number;
	shortCode: string;
	status: string;
	testID: string;
};

export type BuyButtonProps = {
	onBuyClick: () => void;
	partnerId: string;
	quantityAvailable: number;
	shortCode: string;
	startDate: string;
	status: string;
	testID: string;
};

export type FanTokenOfferingHowToProps = {
	closeModal: () => void;
	fanTokenOfferingId: string;
	onClick?: () => void;
	onPress?: () => void;
	shortCode: string;
	testID: string;
};

export type FanTokenOfferingDisclaimerProps = {
	closeModal: () => void;
	onAgree?: () => void;
	onDisagree?: () => void;
	requirement: UserRequirement;
	testID: string;
};

export type FanTokenOfferingReviewContentProps = {
	amounts?: OrderReviewAmounts;
	data: OrderReviewData;
	isLoading?: boolean;
	lobby?: FanTokenOfferingData;
	setTermsAccepted: (value: boolean) => void;
	termsAccepted: boolean;
	testID: string;
};

export const enum FTOCardStatus {
	AIRDROP_PROCESSING = 'airdropProcessing',
	CLAIMABLE_PERIOD_CLOSED = 'claimablePeriodClosed',
	CLAIMABLE_PERIOD_ONGOING = 'claimablePeriodOngoing',
	CLOSED = 'closed',
	FINISHED = 'finished',
	LOCKED = 'locked',
	OPENED = 'opened',
	PUBLISHED = 'published'
}
